import { ButtonThemeColor } from '@tmh-website/ui/Button';
import { ArrowUpRight } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { AdjustedButtonOutlined } from './LinkPartnershop.styles';

type LinkPartnershopProps = {
  inMenu?: boolean;
  outlineButtonThemeColor: ButtonThemeColor;
};

export const LinkPartnershop = ({ inMenu, outlineButtonThemeColor }: LinkPartnershopProps) => {
  const { t } = useTranslation();
  const url = t('global:menu.partnershopButton.url');
  const label = t('global:menu.partnershopButton.label');
  const ariaLabel = t('global:menu.partnershopButton.ariaLabel');

  return (
    <AdjustedButtonOutlined
      $hideOnMobile={!inMenu}
      iconRight={<ArrowUpRight weight='bold' size={20} />}
      type='button'
      isSmall={true}
      href={url}
      themeColor={outlineButtonThemeColor}
      target='_blank'
      aria-label={ariaLabel}>
      {label}
    </AdjustedButtonOutlined>
  );
};
